import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
// eslint-disable-next-line
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import sagaMonitor from '@redux-saga/simple-saga-monitor';
import rootReducer from '../reducers';
import accountSaga from '../sagas/account';
import * as actionCreators from '../actions/index';
export default function configureStore(initialState) {
    const sagaMiddleware = createSagaMiddleware({ sagaMonitor });
    // 'devToolsEnhancer' provides tracing of action calls, which is useful when
    // inspecting actions in redux devtools browser plugin.
    const devToolsEnhancer = composeWithDevTools({
        actionCreators,
        trace: true,
        traceLimit: 25,
    });
    const store = createStore(rootReducer, initialState, devToolsEnhancer(applyMiddleware(sagaMiddleware, thunk)));
    store.sagaTask = sagaMiddleware.run(accountSaga);
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
            // eslint-disable-next-line global-require
            const nextReducer = require('../reducers').default;
            store.replaceReducer(nextReducer);
        });
    }
    window.store = store;
    if (window.electronIPC) {
        window.electronIPC.onReduxAction((emitter, action) => store.dispatch(action));
    }
    return store;
}
